var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100vh-100"},[_c('ReportGnbDataMenu',{ref:"reportGnbDataMenuRef"}),_c('ReportGnbTaskList',{ref:"reportGnbTaskListRef",attrs:{"dataLength":_vm.dataLength},on:{"getDataByTaskId":_vm.getDataByTaskId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }